import React from "react";
import cx from "classnames";

import { Heading } from "components/ui/Heading";
import { Button } from "components/ui/Button";

import * as s from "./PartnerReviewCard.module.sass";

export type IArticle = {
  title: string;
  description: string;
  link: string;
  date: string;
};

type PartnerReviewCardProps = {
  article: IArticle;
};

export const PartnerReviewCard: FC<PartnerReviewCardProps> = ({
  article: { title, description, link, date },
  className,
}) => (
  <div className={cx(s.root, className)}>
    <Heading type="h4" as="h3" className={s.title}>
      {title}
    </Heading>
    <p>{description}</p>
    <div className={s.footer}>
      <Button theme="tertiary" href={link} className={s.link}>
        {link}
      </Button>
      <span>{date}</span>
    </div>
  </div>
);
